import store from '@/store';

export default function isRole(type) {
  const user = store.getters['app/currentUser'];
  return user.role.type === type;
}
